import { metaPublic } from '@/router/meta-config'
// routes
import appRoutes from './app-routes'
import events from './events'
import categories from './categories'
import attributes from './attributes'
import places from './places'
import ordersEvent from './ordersEvent'
import cities from './cities'
import pages from './pages'
import mediaLibrary from './media-library'
import routes from './routes'
import blogPosts from './blogPosts.js'
import blogCategories from './blogCategories.js'
import kioskDevices from './kiosk-devices'
import streams from '@/router/routes/streams'
import placesCategories from './placesCategories.js'
import audioguides from './audioguides.js'
import guides from './guides.js'
import accounts from './accounts.js'
import infoPages from './info-page'
import infoCategories from './info-categories'
import roles from '@/router/routes/roles'
import dictionaries from './dictionaries'
import actionsDictionaries from './actionsDictionary'
import seoConfigs from './soe-configs'
import historicalFigures from './historical-figures'
import hotels from '@/router/routes/hotels'
import AdPlacements from '@/router/routes/ad-placements'
import CulturalOrganisations from '@/router/routes/cultural-organizations'
import touristAgencies from '@/router/routes/tourist-agencies'
import eventOrganizers from '@/router/routes/event-organizers'
import personalDetails from '@/router/routes/personal-details'
import legalDetails from '@/router/routes/legal-details'
import sharedAccess from '@/router/routes/shared-access'
import ordersBooking from '@/router/routes/ordersBooking'

// routes collection
export default [
  ...appRoutes,
  ...events,
  ...categories,
  ...attributes,
  ...places,
  ...ordersEvent,
  ...ordersBooking,
  ...cities,
  ...pages,
  ...mediaLibrary,
  ...routes,
  ...blogPosts,
  ...blogCategories,
  ...kioskDevices,
  ...streams,
  ...placesCategories,
  ...audioguides,
  ...guides,
  ...accounts,
  ...infoPages,
  ...roles,
  ...dictionaries,
  ...actionsDictionaries,
  ...infoCategories,
  ...seoConfigs,
  ...historicalFigures,
  ...hotels,
  ...AdPlacements,
  ...CulturalOrganisations,
  ...touristAgencies,
  ...eventOrganizers,
  ...personalDetails,
  ...legalDetails,
  ...sharedAccess,
  // 404
  {
    path: '/*',
    name: 'page-404',
    component: () => import('@/pages/404'),
    meta: metaPublic
  }
]
